// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import style from './PurchaserInfo.scss';
import icons from '../../../../../assets/styles/icons.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import avatarStyle from '../../../../../assets/styles/avatar.scss';
import defaultPic from '../../../../../assets/img/profileplaceholder.jpg';

import type { Flight, Order, UserMini, Address } from '../../../../../entities';

type Props = {
  order: Order;
};

export default class PurchaserInfo extends Component<Props> {
  render() {
    const { order } = this.props;
    const menuOptions = [
      {
        labelIntl: 'order.travelerInfo.report',
        icon: icons.symbolWarning,
        color: 'red',
        handler: () => {
          console.log('click');
        },
      },
    ];
    const purchaser: ?UserMini = order.purchaser;
    const shippingAddress: ?Address = order.shippingAddress;

    return purchaser ? (
      <section className={classNames(boxStyle.box, style.box)}>
        {/*<DotsMenu orientation="left"
                  buttonStyle={style.dotsButton}
                  menuOptions={menuOptions}/>*/}
        <article className={style.topContent}>
          <img src={purchaser.image || defaultPic}
               className={classNames(avatarStyle.avatar, avatarStyle.large, {[style.middle]: !shippingAddress})}/>
          <section className={classNames(style.infoWrap, {[style.middle]: !shippingAddress})}>
            <p className={style.name}>{purchaser.firstName}</p>
            {shippingAddress && <p className={style.shippingAddress}>{shippingAddress.admin1.name},
              {` ${order.deliveryCountry.code3}`}</p>}
          </section>
        </article>
        {/*!['TRAVELER_CANCELED', 'DELIVERY_CONFIRMED'].includes(order.state) &&
        <article className={style.bottomContent}>
          <FormattedMessage id="order.purchaserInfo.timeLimit">{
            txt => <p>
              <i className={icons.iconDeliverBoxMedium}/>{txt}: {moment(order.beforeDate).format('DD MMM YYYY')}
            </p>
          }</FormattedMessage>
        </article>*/}
      </section>
    ) : null;
  }
}

PurchaserInfo.propTypes = {
  order: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Sale/components/PurchaserInfo/PurchaserInfo.jsx